module.exports = __webpack_public_path__ + "static/media/project-thumbnail20.e09fe775.jpg";